import { paths } from 'src/routes/paths';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

export const navData = [
  {
    title: 'Categories',
    icon: <Iconify icon="solar:widget-bold-duotone" width={24} />,
    path: '/',
  },
  {
    title: 'Shop',
    icon: <Iconify icon="eva:search-fill" width={24} />,
    path: paths.shop,
  },
];
